import { ReactComponent as Google } from './icon_google.svg';
import Icon, { IconProps } from './icon';

const IconGoogle = (props: IconProps) => {
  return <Icon {...props} Svg={Google} />;
};

export default IconGoogle;
